import React, { FC, useMemo } from 'react'
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { RewardsQuery } from '../../../../../../graphql/search'
import {
  monthName,
  monthNameShort,
  parseRewardsPeriod,
} from '../../../../../../lib/rewards/periods'
import { dropZeroCents, formatAsCurrencyWithCommasOrZero } from '../../../../../../utils/priceTools'
import { RewardsHeading4 } from '../../RewardsHeading'
import * as Styled from './styled'

export interface SalesAnalyticsCardProps {
  className?: string
  rewardsSnapshots: NonNullable<NonNullable<RewardsQuery['customer']>['rewardsSnapshots']>['nodes']
}

const dataCount = 6

export const SalesAnalyticsCard: FC<SalesAnalyticsCardProps> = ({
  className,
  rewardsSnapshots,
}) => {
  const data = useMemo(
    () =>
      [...rewardsSnapshots]
        .sort((a, b) => a.period.localeCompare(b.period))
        .slice(-Math.abs(dataCount))
        .map((snapshot) => {
          const period = parseRewardsPeriod(snapshot.period)
          const sales = snapshot.sales.total
          return {
            month: period?.month ?? 0,
            salesTotal: parseFloat(sales.amount),
          }
        }),
    [rewardsSnapshots],
  )
  if (data.length === 0) {
    return null
  }
  return (
    <Styled.Card className={className}>
      <RewardsHeading4>Sales Analytics</RewardsHeading4>
      <Styled.Container>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <XAxis
              dataKey="month"
              tickFormatter={(value) => (value === 0 ? '' : monthNameShort(value as number) ?? '')}
              stroke="#232427"
            />
            <YAxis
              dataKey="salesTotal"
              tickFormatter={(value) =>
                value === 0
                  ? ''
                  : dropZeroCents(formatAsCurrencyWithCommasOrZero({ amount: value as number }))
              }
              stroke="#232427"
            />
            <Tooltip
              labelFormatter={(value) => (value === 0 ? '' : monthName(value as number) ?? '')}
              formatter={(value) => [
                dropZeroCents(formatAsCurrencyWithCommasOrZero({ amount: value as number })),
                'Qualifying Sales',
              ]}
            />
            <Bar dataKey="salesTotal" barSize={23} fill="#1A428A" />
          </BarChart>
        </ResponsiveContainer>
      </Styled.Container>
    </Styled.Card>
  )
}
